/**
 * @file functions/logError.ts
 * 
 * Utility function for logging errors to both the console and New Relic.
 * 
 * Usage:
 *   logError(new Error('Something went wrong'), 'Checkout Process');
 *
 * @param error - The caught error object (can be any type).
 * @param context - Optional context string or metadata for debugging.
 */
export function logError(
  err: unknown,
  context?: string | Record<string, unknown>,
) {
  const error = err instanceof Error ? err : new Error(String(err));

  if (typeof window === 'undefined') {
    try {
      /* eslint-disable @typescript-eslint/no-explicit-any */
      const newrelic: any = (eval('require') as NodeJS.Require)('newrelic');

      if (typeof newrelic?.noticeError === 'function') {
        if (context && typeof context === 'object') {
          newrelic.noticeError(error, context);
        } else {
          newrelic.noticeError(error);
        }
      }
    } catch {
      /* No Operation – New Relic is not installed and/or disabled */
    }
  }

  // Also log to console
  if (context) {
    console.error(context, error);
  } else {
    console.error(error);
  }
}
